export default "__VITE_ASSET__c17c10b5__"